import type { PrimitiveCameraConfig } from '@/adapters/primitive/_contract/camera';

export const PRIMITIVE_CAMERA_DEFAULTS: PrimitiveCameraConfig = {
    base: {
        pose: {
            position: [8, 26, 20],
            target: [4, 0, -4],
            fov: 50,
        },
        navigationMode: 'guided',
        overviewDirection: [0.56, 0.5, -0.66],
        padding: 1.15,
        fov: 50,
        navigationDurationMs: 700,
    },
    boolean: {
        graphInspectionDirection: [0.3, 0.5, 0],
    },
    natural: {
        resultSettlementOffset: [10, 2, 6],
        compositeSettlementOffset: [10, 2, -1],
        dispatchHoldDurationMs: 500,
    },
};
